import * as React from 'react';

import { OrderNotesProps } from '../../components/cart/order-notes';

const OrderNotesView: React.StatelessComponent<OrderNotesProps> = props => {

    function onChange(evt: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedValue = evt.currentTarget.value;
        props.updateOrderNotes(updatedValue);
    }

    return (

        <div className="stack-xs">
            <label htmlFor="txtArea">{props.orderNotesTitle}</label>
            <textarea maxLength={250} id="txtArea" placeholder={props.orderNotesPlaceholder}
                onChange={(evt) => {
                    onChange(evt);
                }}
                value={props.orderNotes != null ? props.orderNotes : ""}
            ></textarea>
        </div>
    );
}

export default OrderNotesView;


